var map = {
	"./component-icons.json": 60481,
	"./dev.json": 25559,
	"./enabled-components.json": 61607,
	"./local.json": 82665,
	"./preprod.json": 18028,
	"./prod.json": 86394,
	"./test.json": 53320
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47771;